<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import Api from '@/services/api'
import { mapGetters, mapActions } from 'vuex'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'

export default {

    data() {
        return {
            authState: undefined 
        }
    },

    computed: {
        ...mapGetters([
            'getTimeSelection',
            'getContrastTimeSelection',
        ]),
    },

    methods: {
        ...mapActions([
            'setTimeSelection',
            'setContrastTimeSelection']),      
    },

    created() {
        this.setTimeSelection(this.getTimeSelection)
        this.setContrastTimeSelection(this.getContrastTimeSelection)
        this.$store.dispatch('auth/fetchUser')
        .then(() => {
            if (this.isAuthenticated()) {
                this.$store.dispatch('fetchWebApps')
            }
        })
        onAuthUIStateChange((state, user) => {
            console.log(`UI state change. new state = ${state}, current state = ${this.authState}`)
            if (state === AuthState.SignedIn && this.authState == AuthState.SignedIn) {
                console.log("Already signed in. No action required")
            } else if (state === AuthState.SignedIn && this.authState != AuthState.SignedIn) {
                console.log("New sign in. Checking email verification status...")
                if (!user.attributes.email_verified) {
                    console.log("Login successful but email not verified yet. Signing out the user.")
                    this.authState = undefined
                    this.$store.dispatch('auth/logout')        
                } else {
                    console.log("Login successful.")
                    this.authState = state            
                    this.$store.dispatch('auth/loggedIn', user)
                }
            } else {
                this.authState = state            
            }
        })            
    },

}

</script>

<style src="vue-d3-network/dist/vue-d3-network.css"></style>
<style src='vue-json-pretty/lib/styles.css'></style>

<style lang="scss">

    :root {
        --amplify-primary-color: #1867c0; // Same as Vuetify "primary" color
        --amplify-primary-tint: #1867c0; // Same as Vuetify "primary" color
    }

    .clickable {
        cursor: pointer;
    }

    // D3 Network
    .d3-network-hidden-node-label {
        display: none;
    }
    .node-label {
        fill: black !important;
        font-size: 16px;
        font-weight: 600;
    }

    // Read more
    .read-more-button {
    //     border-top-style: dotted !important;
    //     border-top-width: 1px !important;
    //     border-top-color: #039BE5 !important;
        font-size: 16px;
    }

    .read-more-button > span {
        // background: #039BE5 !important;
        // color: white !important;
        // border-radius: 12px;
        color: #616161 !important;

    }

    // json compare
    .c-json-p {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
        margin-top: 4px !important;
        margin-bottom: 4px !important
    }

    .c-json-outter {
        margin: 0px !important
    }

    .c-json-view {
        line-height: 4px !important;
    }

    // monospace
    .monospace, .vjs-tree .vjs-value__string  {
        font-family: Monaco,Menlo,Consolas,"Bitstream Vera Sans Mono",monospace !important;
        font-size: 14px !important;
        color: black !important;
    }

    .underlined-title {
        border-bottom: 1px solid #BDBDBD;
    }

    .underlined-title.dark {
        border-bottom: 1px solid #757575;
    }

    // Text transformation
    .text-transform-none {
        text-transform: none !important;
    }

    // Double border
    .double-grey-border {
        border-radius: 10px;
        border: 2px solid #E0E0E0;        
        box-shadow: 0 0 0 24px white, 0 0 0 26px #E0E0E0;
                        
    }

    .grey-border {
        border-radius: 10px;
        border: 2px solid #E0E0E0;        
    }

    .v-btn--active.no-active::before {
    opacity: 0 !important;
    }    

</style>
